import { render } from "./WarningText.vue?vue&type=template&id=2cb38b1d"
import script from "./WarningText.vue?vue&type=script&lang=js"
export * from "./WarningText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__